$(document).ready(function() {
  /* 機種名をtagから取得して表示 */
  function textTrim(text, count) {
    if (text.length > count) {
      var showText = text.substring(0, count);
      showText += '…';
      return showText;
    } else {
      return text;
    }
  }
  $('.js-section-product').each(function () {
    var itemtitle = $(this).data('product-item-title');
    var tags = $(this).data('product-tags');
    var phone = $(this).data('product-item-phone');
    var base_model_code = tags.find(function (code) {
      return code.indexOf('mo_') === 0;
    });
    var base_casetype_name = tags.find(function(code) {
      return code.indexOf('h1_') === 0;
    });
    var base_itemtitle = tags.find(function (code) {
      return code.indexOf('productname_') === 0;
    });
    if (base_itemtitle) {
      base_itemtitle = base_itemtitle.replace('productname_','');
    } else {
      base_itemtitle = itemtitle;
    }
    if (base_model_code) {
      var deleted_prefix = base_model_code.split('_')[1]
      var base_model_name = window.fox.settings.model[deleted_prefix];
      $('.js-model',this).text(base_model_name);
    }
    if (base_casetype_name){
      var base_casetype_name = window.fox.settings.h1[base_casetype_name];
      $('.js-casetype',this).text(base_casetype_name);
    }
    if (base_itemtitle) {
      base_itemtitle = textTrim(base_itemtitle, 22);
      if (window.matchMedia('(max-width: 600px)').matches) {
        base_itemtitle = textTrim(base_itemtitle, 22);
      }
      $('.js-item-title',this).text(base_itemtitle);
    }
  });
  /* 検索タイトルのh2タグを消す */
  if($(document).hasClass('collection-title')){
    var collection_title = $('.collection-title').html();
    $('.collection-title').html(
      collection_title.replace(/h2_.+?\s/i,'')
    );
  }
  /* パンくずリストのh2タグを消す */
  if($(document).hasClass('breadcrumbs-inner')){
    var breadcrumbs_inner = $('.breadcrumbs-inner').html();
    if(breadcrumbs_inner.match(/h2_/)){
      $('.breadcrumbs-inner').html(
        breadcrumbs_inner.replace(/h2_.+?\s/i,'').replace(/\+/,'')
      );
    }
  }
});
